import { render, staticRenderFns } from "./packageType.vue?vue&type=template&id=54fc58f3&"
import script from "./packageType.vue?vue&type=script&lang=js&"
export * from "./packageType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports